// @ts-nocheck
export interface ScrollToIdOptions {
    /**
     * If true, will focus the target
     */
    focus?: boolean;
    /**
     * If true, the `focus` option is ignored and will only focus the target and not scroll.
     */
    onlyFocus?: boolean;
    /**
     * If set, will adjust the scroll in pixel according to the given value
     */
    padding?: number;
    /**
     * If true, will scroll smoothly to the target
     */
    smooth?: boolean;
}

const scrollToId = (idOrElement: string | HTMLElement, options?: ScrollToIdOptions) => {
    const elementToScrollTo = typeof idOrElement === "string" ? document.getElementById(idOrElement) : idOrElement;

    if (!elementToScrollTo) {
        return;
    }

    const { focus, onlyFocus, padding, smooth } = options || {};

    if (!onlyFocus) {
        const viewportPosition = elementToScrollTo.getBoundingClientRect().top || 0;
        const viewportToDocument = window.scrollY;
        const scrollTopPx = viewportPosition + viewportToDocument - (padding || 0);
        const scrollBehavior = smooth ? "smooth" : "auto";

        if (document.body.scrollTop) {
            window.document.body.scrollTop = scrollTopPx; // Safari
        }

        window.scrollTo({
            top: scrollTopPx,
            behavior: scrollBehavior,
        }); // Chrome, Firefox, IE and Opera
    }

    if (onlyFocus || focus) {
        elementToScrollTo.focus();
    }
};

export default scrollToId;
